import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getExperiments } from '@hungryroot/rest/api/v2/experiments/get';

interface Params {
  limit?: number;
  offset?: number;
}

export function useExperiments(params: Params = { limit: 1000, offset: 0 }) {
  return useQuery({
    queryKey: ['experiments', params],
    queryFn: async () => {
      const resp = await getExperiments(params);
      const { status, data } = resp;

      if (
        status < StatusCode.SuccessOK ||
        status > StatusCode.RedirectMultipleChoices
      ) {
        throw data;
      }

      return data;
    },
  });
}
